import React, { useEffect, useState } from "react";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import FooterSection from "../component/layout/footer";
import phone from "phone";
import axios from "axios";
import { config } from "../config";
import { toast } from "react-toastify";
import Loader from "../component/section/loader";
import Notify from "simple-notify";

const titel = "Request Account Deletion and Data Erasure on Tegal";
const desc =
  "To delete your account and erase all your data on Tegal, please provide the following details:";
const btnText = "Submit Request";

function DeletionPage() {
  const [isLoading, setLoader] = useState(false);
  const [input, setInput] = useState({
    name: "",
    emailAddress: "",
    subject: "Account Deletion Request",
    message: "",
    reason:"",
  });

  const submit = () => {
    if (
      input.name !== "" &&
      input.emailAddress !== "" &&
      input.subject !== "" &&
      input.message !== ""
    ) {
      setLoader(true);
      axios
        .post(config.baseURL + "/api/v1/message/public", input)
        .then(function (response) {
          setLoader(false);
          if (response.data.success) {
            setInput({
              name: "",
              emailAddress: "",
              subject: "",
              message: "",
            });
            new Notify({
              title: "Request Successul",
              text: "Your account deletion has been submited, our team will engage you in 24 hrs and all your data will be erased from Tegal after all.",
              status: "success",
              showCloseButton: true,
              autoclose: false,
            });
            setTimeout(() => {
              window.location.href = "/";
            }, 50000);
          } else {
            setLoader(false);
            toast.warn(response.data.message);
          }
        })
        .catch(function (error) {
          setLoader(false);
          toast.error("Unable to send message");
        });
    } else {
      toast.warning("All fields required");
    }
  };

  return (
    <div>
      <Header />
      <PageHeader title={"Delete Account"} />
      <div className="contact-section">
        <div className="contact-top padding-tb aside-bg padding-b">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <article className="contact-form-wrapper">
                  <div className="contact-form">
                    <h4>{titel}</h4>
                    <p className="mb-5">{desc}</p>
                    <form
                      action="#"
                      method="POST"
                      id="commentform"
                      className="comment-form"
                    >
                      <input
                        type="text"
                        name="name"
                        id="item01"
                        value={input.name}
                        onChange={(e) => {
                          setInput({ ...input, name: e.target.value });
                        }}
                        placeholder="Your Name *"
                      />
                      <input
                        type="text"
                        name="email"
                        id="item02"
                        value={input.emailAddress}
                        onChange={(e) => {
                          setInput({ ...input, emailAddress: e.target.value });
                        }}
                        placeholder="Your Tegal Email or Phone Number*"
                      />
                      <input
                        type="text"
                        name="subject"
                        id="item03"
                         value={input.reason}
                        onChange={(e) => {
                          setInput({ ...input, reason: e.target.value });
                        }}
                        placeholder="Reason *"
                      />
                      <input
                        type="text"
                        name="subject"
                        id="item03"
                        readOnly
                        disabled
                        value={input.subject}
                        onChange={(e) => {
                          setInput({ ...input, subject: e.target.value });
                        }}
                        placeholder="Subject *"
                      />

                      <textarea
                        rows="8"
                        type="text"
                        id="item05"
                        name="message"
                        value={input.message}
                        onChange={(e) => {
                          setInput({ ...input, message: e.target.value });
                        }}
                        placeholder="Additional information"
                      ></textarea>
                      <button
                        type="button"
                        className="lab-btn"
                        onClick={!isLoading ? submit : {}}
                      >
                        {isLoading ? <Loader /> : <span>{btnText}</span>}
                      </button>
                    </form>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterSection />
    </div>
  );
}

export default DeletionPage;
